import { css } from 'styled-components';

export const ProductV2SelectCss = css`
    .product-v2-option {
        .option-wrapper {
            width: 100% !important;
            height: 41px !important;
    
            .ant-row {
              margin-bottom: 0 !important;
            }
        
            .option-row {
                padding: 1px 0;
            }
        
            .image-col {
                text-align: center;
        
                img {
                    max-width: 35px;
                    max-height: 35px;
                    padding: 2px 0;
                    background: #f0f0f0;
                }
            }
        
            .content-col {
                width: 283px;
                
                .ant-col {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
        
                .name-row {
                    font-weight: 500;
                    line-height: 145%;
                    color: #141414;
        
                    .subscription-lock-wrapper {
                        display: flex;
                    }
                }
        
                .product-info-row {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 145%;
                    color: #595959;
        
                    .left-col {
                        &.fading-div {
                        overflow: hidden;
                        text-overflow: unset;
                        white-space: nowrap;
                        mask-image: linear-gradient(to right, rgba(0,0,0,100%) 90%, rgba(0,0,0,0%));
        
                        .product-group-tags {
                            .ant-tag {
                                font-size: 12px;
                                line-height: 14px;
                                color: rgba(0, 0, 0, 65%);
                                }
                            }
                        }
                    }
        
                    .right-col {
                        text-align: end;
                    }
        
                }
            }
        }

        &.ant-select-item-option-disabled {
            .option-wrapper {   
                .image-col {
                    img {
                        opacity: 0.5;
                    }
                }

                .content-col {
                    .name-row, .product-info-row {
                        color: rgba(0, 0, 0, 25%);
                    }
                }
            }
        }
    }
    
`;
